function escapeHtml(s: string): string {
  return s.replace(/[&<>"]/g, (c) => `&#${c.charCodeAt(0)};`);
}

/** ADS-B emitter category → human type label (mirrors targets.ts wording). */
export function categoryTypeLabel(category: string | null | undefined): string {
  switch (category) {
    case 'A5':
      return 'Commercial Heavy';
    case 'A3':
    case 'A4':
      return 'Commercial Jet';
    case 'A1':
    case 'A2':
      return 'GA Aircraft';
    case 'A7':
      return 'Rotorcraft';
    case 'B2':
      return 'Balloon';
    default:
      return 'Aircraft';
  }
}

/** Dark hover card (Surveillance/target tooltip parity — image 5). `rows`
 *  values may contain trusted HTML (e.g. a coloured status span); callers must
 *  pre-escape any payload-derived text in values. Keys are escaped here. */
export function buildDarkCardHtml(header: string, rows: Array<[string, string]>): string {
  const rowsHtml = rows
    .map(
      ([k, v]) =>
        `<div style="display:flex;justify-content:space-between;gap:18px"><span style="color:rgba(255,255,255,.5)">${escapeHtml(k)}</span><span>${v}</span></div>`,
    )
    .join('');
  return `<div style="position:relative;background:#131a11;color:#f0f4f0;border-radius:8px;padding:10px 13px;font-family:IBM Plex Mono,monospace;font-size:11px;line-height:1.75;white-space:nowrap;box-shadow:0 4px 16px rgba(0,0,0,.25);min-width:185px;pointer-events:none"><div style="font-size:0.923em;font-weight:600;color:#fff;margin-bottom:5px;font-family:Inter,sans-serif">${escapeHtml(header)}</div>${rowsHtml}<div style="position:absolute;top:100%;left:50%;transform:translateX(-50%);border:5px solid transparent;border-top-color:#131a11"></div></div>`;
}

/** White hover card (Surveillance sensor popup parity — image 6). */
export function buildLightCardHtml(
  id: string,
  service: string,
  serviceColor: string,
  label: string,
): string {
  return `<div style="position:relative;background:#fff;border-radius:6px;padding:7px 10px;font-family:IBM Plex Mono,monospace;font-size:11px;line-height:1.45;color:#1f2937;box-shadow:0 2px 10px rgba(0,0,0,.18);min-width:140px;max-width:240px;pointer-events:none"><div style="font-weight:700">${escapeHtml(id)}</div>${
    service
      ? `<div style="font-weight:600;color:${serviceColor};margin-top:2px">${escapeHtml(service)}</div>`
      : ''
  }${label ? `<div style="color:#555;margin-top:1px">${escapeHtml(label)}</div>` : ''}<div style="position:absolute;top:100%;left:50%;transform:translateX(-50%);border:5px solid transparent;border-top-color:#fff"></div></div>`;
}
